/**
 * See more functionality
 */

const seeMore = function() {
  const btns = document.querySelectorAll(".js-accordion-btn");
  const panels = document.querySelectorAll(".js-accordion-panel");
  const containers = document.querySelectorAll(".lp__works-section");
  const more = "Show More";
  const less = "Show Less";

  btns.forEach( (btn, i) => {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      
      const panel = panels[i];
      const container = containers[i];
      
      if (panel?.classList.contains("show")) {
        container?.scrollIntoView({ behavior: "auto" })
        setTimeout(() => {
          panel?.classList.remove("show");
          btn.textContent = more;
        }, 500);
      } else {
        panel.classList.add("show");
        btn.textContent = less;
      };
    })
  });
};

export default seeMore;